document.addEventListener('DOMContentLoaded', function () {
    const blockInsights = document.querySelectorAll('.block-insights');

    if (blockInsights.length === 0) return;

    blockInsights.forEach(function (blockInsights) {
        setupBlockInsightsEdgeGrid(blockInsights);
    });
});

function setupBlockInsightsEdgeGrid(blockInsights) {
    const blockInsightsGrid = blockInsights.querySelector('.block-insights__grid');

    if (!blockInsightsGrid) return;

    const setBlockInsightsGridWidth = function () {
        const blockInsightsGridRect = blockInsightsGrid.getBoundingClientRect();
        const blockInsightsGridContainer = blockInsightsGrid.parentElement;
        let blockInsightsGridContainerWidth = blockInsightsGrid.offsetWidth;
        const blockInsightsGridWidth = window.innerWidth - blockInsightsGridRect.left;

        if (blockInsightsGridContainer) {
            const blockInsightsGridContainerStyles = window.getComputedStyle(blockInsightsGridContainer);
            const blockInsightsGridContainerPadding = parseFloat(blockInsightsGridContainerStyles.paddingLeft) + parseFloat(blockInsightsGridContainerStyles.paddingRight);

            blockInsightsGridContainerWidth = blockInsightsGridContainer.clientWidth - blockInsightsGridContainerPadding;
        }

        blockInsightsGrid.style.setProperty('--insights-grid-container-width', blockInsightsGridContainerWidth + 'px');
        blockInsightsGrid.style.setProperty('--insights-grid-edge-width', blockInsightsGridWidth + 'px');
    };

    setBlockInsightsGridWidth();
    window.addEventListener('resize', setBlockInsightsGridWidth, { passive: true });
}
